import { SCREEN_PRESENTER } from '@shoflo/polymer';
import createSource from './createSource';
import updateSource from './updateSource';
import { UNASSIGNED } from 'utils/broadcastSourceHelper';

export default () => {
  return (dispatch, getState) => {
    const state = getState();
    const {
      meeting: { attendeeResponse },
      broadcastSources: { sources },
      user
    } = state;

    const directorId =
      attendeeResponse && attendeeResponse?.Attendee?.AttendeeId;

    if (directorId) {
      const directorScreenShareAttendeeId = `${directorId}#content`;
      const directorScreenShareExists = sources.find(
        source => source.value === directorScreenShareAttendeeId
      );

      if (directorScreenShareExists) {
        // Source already exists, no need to create or update
        return;
      }

      let title = `${directorId}`;
      const directorSource = sources.find(
        source => source.value === directorId
      );
      if (directorSource && directorSource.title) {
        title = directorSource.title;
      }

      // Check for unassigned screen share source with matching createdBy and title
      const unassignedScreenShare = sources.find(
        source =>
          source.type === SCREEN_PRESENTER &&
          source.value === UNASSIGNED &&
          source.createdBy === user._id &&
          source.title === title
      );

      if (unassignedScreenShare) {
        // Reuse the existing unassigned screen share source
        dispatch(
          updateSource(unassignedScreenShare._id, {
            value: directorScreenShareAttendeeId,
            title
          })
        );
      } else {
        dispatch(
          createSource({
            title,
            type: SCREEN_PRESENTER,
            value: directorScreenShareAttendeeId
          })
        );
      }
    }
  };
};
